import { SENSOR_READING_TYPES } from '../constants'

const MIC_COUNT_Y_AXIS_TITLE = 'Samples ≥ 85 dB per 10 min'

const getChartTypeKey = (pageSlug, reading) => `${pageSlug}::${reading}`

const getDefaultChartType = reading =>
  reading === SENSOR_READING_TYPES.MIC_COUNT ? 'column' : 'line'

const resolveChartType = (chartTypes, pageSlug, reading) =>
  chartTypes[getChartTypeKey(pageSlug, reading)] || getDefaultChartType(reading)

const getYAxisTitle = (reading, readingName, readingUnit) => {
  if (reading === SENSOR_READING_TYPES.MIC_COUNT) return MIC_COUNT_Y_AXIS_TITLE
  return readingUnit ? `${readingName} (${readingUnit.trim()})` : readingName
}

export {
  getChartTypeKey,
  getDefaultChartType,
  resolveChartType,
  getYAxisTitle,
}
